<div class="wrapper">
    <div class="page-wrapper pt-4">
        <div class="page-content pt-0 pe-2 ps-2">
            <div class="container-fluid">
                <div class="default_class">
                    <div class="content-wrapper p-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="card rounded shadow-lg">
                                        <div class="card-header headerbg" style="border-bottom: 3px solid #d8eff8">
                                            <h5 class="mb-0">{{lable}} User Manual</h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="col-xl-12">
                                                <div id="htmldiv" class="unselectable" style="font-size: 16px;color:#4c5a73" [innerHTML]="htmlContent">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>